import { withAntePostBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/antePostBased';

import type { SportsAntePostEventsState } from './types';

export const defaultState = withAntePostBasedMarketTemplateModelState<SportsAntePostEventsState>({
  isLoading: false,
  hasPreloaded: false,
  templateGroups: []
});
